import Vue from 'vue'
import VueMask from 'v-mask'
import VueMq from 'vue-mq'
import App from './App.vue'
import filters from './utils/filters'
import { getDomain } from './utils/domain'
import BootstrapVue from 'bootstrap-vue'
import VueMultiselect from 'vue-multiselect'
import VuePikaday from '@enrian/vue-pikaday'
import { L } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import VueLazyLoad from 'vue-lazyload'
import store from '@/store'
import CommonApi from '@/api/commonApi'
import VueEvents from 'vue-events'
import Vue2Filters from 'vue2-filters'
import Vue2FiltersConfig from '@/conf/vue2filters'

// Register custom fields
import autocompleteField from '@/components/form/fields/autocomplete.vue'
import editorField from '@/components/form/fields/editor.vue'
import entityCollectionField from '@/components/form/fields/entitycollection.vue'

// CoolLightBox --- don't remove the following lines or CoolLigntBox doesn't works
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

import router, { accessibleRoutesWithoutAuthentication } from './router'

/*
 * Lang management
 */
import i18n from '@/utils/i18n.js'
Vue.component('fieldEntitycollection', entityCollectionField)
Vue.component('fieldAutocomplete', autocompleteField)
Vue.component('fieldEditor', editorField)

// ?
Vue.config.productionTip = false

// this part resolve an issue where the markers would not appear
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

//
Vue.use(BootstrapVue)
Vue.use(VuePikaday)
Vue.use(VueLazyLoad)
Vue.use(Vue2Filters, Vue2FiltersConfig)
Vue.use(VueMask, {
  placeholders: {
    'A': null,
    'N': null,
    'X': null,
    '?': /[a-zA-Z]/
  }
})
Vue.use(CoolLightBox)

// globally register components
Vue.component(
  'multiselect',
  VueMultiselect
)

// Subscribe to store updates
store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  localStorage.setItem('store', JSON.stringify(state))
})

// Breakpoints for devices
Vue.use(VueMq, {
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    mdplus: 1200,
    lg: 1400,
    xl: 1700,
    xxl: Infinity
  }
})

// Events
Vue.use(VueEvents)

new Vue({
  router,
  i18n,
  filters,
  Vue2Filters,
  store,
  data () {
    return {
      isIE: false
    }
  },
  beforeCreate () {
    this.$store.commit('initialiseStore')
  },
  mounted: function () {
    this.$nextTick(this.ping(router))
    this.testIEUserAgent()
  },
  methods: {
    ping: function (router) {

      let domain = getDomain()

      if (!window.location.href.match(/login$/)) {
        let commonApi = new CommonApi()
        let company = this.$store.getters['security/company'];
        let isFormationSubdomain = domain === "formation"
        let isContigentsSubdomain = domain === "contingents"

        // Si je suis connecté en tant qu'utilisateur FORMATION, je me déconnecte
        if (company && company.hasOwnProperty('name') && company.name.includes("FORMATION")) {
          this.$store.commit('security/QUITTING')
        }
        commonApi.ping()
          .then(response => {
            // Si je ne suis pas sur le sous-domaine formation mais que je suis connecté en tant qu'utilisateur formation, alors je redirige vers le login
            if (!isFormationSubdomain && response.data.company && response.data.company.hasOwnProperty('name') && response.data.company.name.includes("FORMATION")) {
              router.push({ path: '/login' })
            } else {
              this.$store.commit('security/AUTHENTICATING_SUCCESS', response.data)
            }
          })
          .catch(function (error) {
            if (accessibleRoutesWithoutAuthentication.indexOf(router.currentRoute.name) === -1 && !isFormationSubdomain) {
              router.push({ path: '/login' })
            }
          })
      }
    },

    testIEUserAgent () {
      if (typeof window !== 'undefined' && window.navigator.userAgent.match(/MSIE |Trident\//i)) {
        this.isIE = true
      }
    }
  },
  render: h => h(App)
}).$mount('#app')
